import axios from 'axios';
import { message } from 'm-ui';
import { storageLocaleValue } from 'locales/I18N';
import { axiosInterceptors } from '@i18n/uc';
import { HTTP_ERROR_MAP } from './constant';

// T1320164: 两小时未调用接口，认为用户未操作，自动刷新页面，更新用户账户状态
function setAutoRefresh() {
    const REFRESH_TIME = 2 * 60 * 60 * 1000;
    let refreshTimer = setTimeout(() => {
        window.location.reload();
    }, REFRESH_TIME);

    return function resetTimerOnRequest() {
        // 调用接口后重置时间
        if (refreshTimer) {
            clearTimeout(refreshTimer);
        }
        refreshTimer = setTimeout(() => {
            window.location.reload();
        }, REFRESH_TIME);
    };
}

const resetTimerOnRequest = setAutoRefresh();

const ins = axios.create();
ins.defaults.withCredentials = true;

ins.interceptors.request.use(axiosInterceptors.request);
ins.interceptors.request.use((config) => {
    config.headers.Accept = 'application/json';
    config.withCredentials = true;
    config.headers['Accept-Language'] = storageLocaleValue;
    config.headers['request-startTime'] = new Date().getTime();
    resetTimerOnRequest();
    return config;
});

ins.interceptors.response.use(
    /**
     * 不需要校验登录的白名单
     */
    axiosInterceptors.response({
        // whiteList: [paths.LOGIN.path, paths.CREATE_ACCOUNT.path, paths.SIGNUP.path],
    }),
);
ins.interceptors.response.use(
    (res) => {
        const { data } = res;
        // const currentTime = new Date().getTime();
        // const startTime = res.config.headers['request-startTime'];
        // const duration = currentTime - startTime;
        if (data && (+data.result === 1 || +data.code === 200)) {
            return res;
        }
        if (data.err_msg) {
            message.error(data.err_msg); // eslint-disable-line @typescript-eslint/no-floating-promises
        } else if (data.message) {
            message.error(data.message); // eslint-disable-line @typescript-eslint/no-floating-promises
        }
        return Promise.reject(res);
    },
    async (err) => {
        if (err.message in HTTP_ERROR_MAP) {
            message.error(HTTP_ERROR_MAP[err.message]);
        }
        Promise.reject(err);
    },
);

export default ins;
